export const translations = {
  en: {
    search: {
      placeholder: 'Search props...',
      filters: 'Filters',
      sort: 'Sort',
      results: '%{count} props found',
      noResults: 'No props found',
    },
    searchv2: {
      pageTitle: 'Explore Props',
      warehouseFilter: {
        title: 'Which local stacks to include',
        searchPlaceholder: 'Search warehouses...',
        selectAll: 'Select All',
        noOrganizations: 'No organizations found',
        loading: 'Loading organizations...',
      },
      tooltips: {
        openMenu: 'Open menu',
        selectWarehouses: 'Select warehouses',
        moreOptions: 'More options',
        showLabels: 'Show Labels',
      },
      moreOptionsPopover: {
        title: 'More Options',
        description: 'Additional settings',
      },
      impactMode: {
        title: 'Impact Mode',
        tooltip: 'Choose a mode to highlight the environmental, community, or cost-saving benefits of shared props on item cards.',
        environment: 'Environment',
        community: 'Community',
        costSavings: 'Cost Savings',
        active: 'Active',
      },
      menu: {
        searchHome: 'Search Home',
        onLoan: 'On Loan',
        checkout: 'Checkout',
        profile: 'Profile',
        signOut: 'Sign Out',
        seeYourImpact: 'See Your Impact',
        settings: 'Settings',
        warehouseLogin: 'Warehouse Manager Login',
        readThe: 'Read the',
        manifesto: 'PropShare Manifesto',
      },
    },
    conveyor: {
      addProps: 'Add some props!',
      emptyBasket: 'Empty basket',
      itemCount: '%{count} item |||| %{count} items',
    },
    cart: {
      title: 'Review Your Cart',
      checkout: 'Submit Request',
      remove: 'Remove',
      maybe: 'Maybe',
      confirmed: 'Confirmed',
      itemsToRequest: 'Items to Request',
      requestDetails: 'Request Details',
      preferredPickupDay: 'Preferred Pickup Day',
      preferredTimeRange: 'Preferred Time Range',
      expectedReturnDate: 'Expected Return Date',
      purpose: 'Purpose / Production',
      purposePlaceholder: 'e.g., Hamlet, Wedding Reception, Art Installation',
      pickupDayPlaceholder: 'Select a day',
      timeRangePlaceholder: 'Select time range',
      notes: 'Special requests / notes (optional)',
      notesPlaceholder: 'Any special handling instructions, alternative return arrangements, etc.',
      impactTitle: "Review This Cart's Impact:",
      environmental: 'Environmental',
      community: 'Community',
      cost: 'Cost',
      emptyBasket: 'No items in this basket',
    },
    impact: {
      environmental: {
        title: 'Environmental Impact',
        co2Saved: 'CO₂ Saved',
        wasteReduced: 'Waste Reduced',
        resourcesConserved: 'Resources Conserved',
      },
      community: {
        title: 'Community Impact',
        organizationsHelped: 'Organizations Helped',
        connectionsBuilt: 'Connections Built',
        resourcesShared: 'Resources Shared',
      },
      cost: {
        title: 'Cost Savings',
        estimatedSavings: 'Estimated Savings',
        rentalVsPurchase: 'vs. Purchase',
        budgetEfficiency: 'Budget Efficiency',
      },
    },
    navigation: {
      search: 'Search',
      inventory: 'Inventory',
      cart: 'Cart',
      requests: 'Requests',
      analytics: 'Analytics',
    },
    common: {
      close: 'Close',
      cancel: 'Cancel',
      save: 'Save',
      delete: 'Delete',
      edit: 'Edit',
      loading: 'Loading...',
      error: 'Error',
      success: 'Success',
    },
    props: {
      available: 'Available',
      reserved: 'Reserved',
      unavailable: 'Unavailable',
      name: 'Name',
      description: 'Description',
      category: 'Category',
      organization: 'Organization',
      location: 'Location',
      condition: 'Condition',
    },
  },
  es: {
    search: {
      placeholder: 'Buscar utilería...',
      filters: 'Filtros',
      sort: 'Ordenar',
      results: '%{count} utilería encontrada |||| %{count} utilería encontradas',
      noResults: 'No se encontró utilería',
    },
    searchv2: {
      pageTitle: 'Explorar Utilería',
      warehouseFilter: {
        title: 'Cuáles pilas locales incluir',
        searchPlaceholder: 'Buscar almacenes...',
        selectAll: 'Seleccionar Todo',
        noOrganizations: 'No se encontraron organizaciones',
        loading: 'Cargando organizaciones...',
      },
      tooltips: {
        openMenu: 'Abrir menú',
        selectWarehouses: 'Seleccionar almacenes',
        moreOptions: 'Más opciones',
        showLabels: 'Mostrar Etiquetas',
      },
      moreOptionsPopover: {
        title: 'Más Opciones',
        description: 'Configuración adicional',
      },
      impactMode: {
        title: 'Modo de Impacto',
        tooltip: 'Elige un modo para resaltar los beneficios ambientales, comunitarios o de ahorro de costos de la utilería compartida en las tarjetas de artículos.',
        environment: 'Ambiente',
        community: 'Comunidad',
        costSavings: 'Ahorro de Costos',
        active: 'Activo',
      },
      menu: {
        searchHome: 'Inicio de Búsqueda',
        onLoan: 'En Préstamo',
        checkout: 'Solicitar',
        profile: 'Perfil',
        signOut: 'Cerrar sesión',
        seeYourImpact: 'Ver Tu Impacto',
        settings: 'Configuración',
        warehouseLogin: 'Inicio de Sesión de Gerente',
        readThe: 'Lee el',
        manifesto: 'Manifiesto PropShare',
      },
    },
    conveyor: {
      addProps: '¡Agrega utilería!',
      emptyBasket: 'Cesta vacía',
      itemCount: '%{count} artículo |||| %{count} artículos',
    },
    cart: {
      title: 'Revisa Tu Carrito',
      checkout: 'Enviar Solicitud',
      remove: 'Eliminar',
      maybe: 'Quizás',
      confirmed: 'Confirmado',
      itemsToRequest: 'Artículos para Solicitar',
      requestDetails: 'Detalles de la Solicitud',
      preferredPickupDay: 'Día de Retiro Preferido',
      preferredTimeRange: 'Franja Horaria Preferida',
      expectedReturnDate: 'Fecha Estimada de Devolución',
      purpose: 'Propósito / Producción',
      purposePlaceholder: 'p.ej., Hamlet, recepción de boda, instalación de arte',
      pickupDayPlaceholder: 'Selecciona un día',
      timeRangePlaceholder: 'Selecciona franja horaria',
      notes: 'Solicitudes especiales / notas (opcional)',
      notesPlaceholder: 'Cualquier instrucción especial de manejo, arreglos alternativos de devolución, etc.',
      impactTitle: 'Revisa el Impacto de Este Carrito:',
      environmental: 'Ambiental',
      community: 'Comunidad',
      cost: 'Costo',
      emptyBasket: 'No hay artículos en esta cesta',
    },
    impact: {
      environmental: {
        title: 'Impacto Ambiental',
        co2Saved: 'CO₂ Ahorrado',
        wasteReduced: 'Residuos Reducidos',
        resourcesConserved: 'Recursos Conservados',
      },
      community: {
        title: 'Impacto Comunitario',
        organizationsHelped: 'Organizaciones Ayudadas',
        connectionsBuilt: 'Conexiones Construidas',
        resourcesShared: 'Recursos Compartidos',
      },
      cost: {
        title: 'Ahorro de Costos',
        estimatedSavings: 'Ahorro Estimado',
        rentalVsPurchase: 'vs. Compra',
        budgetEfficiency: 'Eficiencia Presupuestaria',
      },
    },
    navigation: {
      search: 'Buscar',
      inventory: 'Inventario',
      cart: 'Carrito',
      requests: 'Solicitudes',
      analytics: 'Análisis',
    },
    common: {
      close: 'Cerrar',
      cancel: 'Cancelar',
      save: 'Guardar',
      delete: 'Eliminar',
      edit: 'Editar',
      loading: 'Cargando...',
      error: 'Error',
      success: 'Éxito',
    },
    props: {
      available: 'Disponible',
      reserved: 'Reservado',
      unavailable: 'No Disponible',
      name: 'Nombre',
      description: 'Descripción',
      category: 'Categoría',
      organization: 'Organización',
      location: 'Ubicación',
      condition: 'Condición',
    },
  },
};
